import { forwardRef } from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const Checkbox = forwardRef(function Checkbox(
  {
    label,
    description,
    error,
    className,
    disabled = false,
    ...props
  },
  ref
) {
  return (
    <div className={twMerge('relative flex items-start', className)}>
      <div className="flex h-6 items-center">
        <input
          ref={ref}
          type="checkbox"
          disabled={disabled}
          className={clsx(
            'h-4 w-4 rounded border-gray-300',
            'text-primary-600 focus:ring-primary-500',
            'disabled:bg-gray-100 disabled:cursor-not-allowed',
            error && 'border-red-500'
          )}
          {...props}
        />
      </div>
      {(label || description) && (
        <div className="ms-3 text-sm leading-6">
          {label && (
            <label
              htmlFor={props.id}
              className={clsx(
                'font-medium',
                disabled ? 'text-gray-400' : 'text-gray-900'
              )}
            >
              {label}
            </label>
          )}
          {description && (
            <p className="text-gray-500">{description}</p>
          )}
          {error && (
            <p className="text-red-600">{error}</p>
          )}
        </div>
      )}
    </div>
  );
});

export default Checkbox;
